import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { useState, useEffect } from 'react';

export const useToken = (scopes = ["User.Read"]) => {
  const { instance, accounts, inProgress } = useMsal();
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(false);

  const getToken = async () => {
    if (inProgress === InteractionStatus.None) {
      setLoading(true);
      const request = {
        scopes,
        account: accounts[0],
      };

      try {
        const response: any = await instance.acquireTokenSilent(request);
        console.log({response});
        setToken(response.accessToken);
        return response.accessToken;
      } catch (error) {
        console.error('Token acquisition failed:', error);
        throw error;
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    getToken();
  }, [instance, accounts, inProgress]);

  return { token, getToken, loading };
};
